import { Image, View } from "@aws-amplify/ui-react";
import { images } from "constants/index";

export const PageEnder = () => {
  return (
    <View
      position="relative"
      display="flex"
      width="100%"
      height="auto"
      paddingTop="30px"
      // backgroundColor="green"
    >
      <div className=" relative w-full h-auto font-lolita-one">
        <div className="w-full text-white  pl-5 pb-3 pr-5">
          Environmental Hood Restoration is a 501c3 based in NYC
        </div>
        <div className="relative flex w-full text-white px-5 pb-5  items-center">
          <div className=" text-[18px] font-light">
            Stay connected! Follow us on social media
          </div>
          <Image
            alt=""
            height={40}
            src={images.instagram}
            onClick={() => {
              window.open(
                "https://www.instagram.com/environmentalhoodrestoration/?hl=en",
              );
            }}
          />
        </div>
      </div>
    </View>
  );
};
